export const LOAD_COMPONENT = 'LOAD_COMPONENT'
export const UNLOAD_COMPONENT = 'UNLOAD_COMPONENT'
